import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import classnames from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      cursor: "pointer",
      color: "#dedede",
      position: "relative",
      minWidth: "110px",
      textAlign: "center",
      marginRight: "1rem",
    },
    active: {
      border: "none",
      backgroundColor: "#FFF !important",
      color: "#2f2f2f !important",
    },
    link: {
      padding: theme.spacing.unit * 2,
      paddingLeft: theme.spacing.unit * 3,
      paddingRight: theme.spacing.unit * 3,
      borderTopRightRadius: "3px",
      borderTopLeftRadius: "3px",
      textDecoration: "none",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-around",
      color: "inherit",
      fontSize: `${theme.typography.fontSize}px`,
    },
    indicator: {
      borderRadius: "50%",
      backgroundColor: "crimson",
      width: "1rem",
      height: "1rem",
      fontSize: "1rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#FFF",
      position: "absolute",
      left: "100%",
      transform: "translate(-50%, -50%)",
      zIndex: 999,
    },
  });

export type MenuItemProps = {
  active?: boolean;
  to: string;
  count?: number;
  className?: string;
  variant?: "dashboard" | "admin" | "report" | "custom";
} & WithStyles<typeof styles>;

const MenuItemUnstlyed: React.FunctionComponent<MenuItemProps> = ({ classes, active, to, children, className, count, variant = "dashboard" }) => {
  return (
    <Typography
      variant="subheading"
      color="inherit"
      className={classnames(classes.root, className, {
        [classes.active]: active,
      })}
    >
      {count && count > 0 ? <div className={classes.indicator} /> : null}
      <Link className={classes.link} to={to}>
        {variant == "admin" ? <FormattedMessage id={children[0].toString()} /> : children}
      </Link>
    </Typography>
  );
};

export const MenuItem = withStyles(styles)(MenuItemUnstlyed);
